import relatorioExameBloqueado from './relatorioExameBloqueadoRepository'
import relatorioPacienteAtendido from '@/repositories/conecta-sus/exame-laboratorial/relatorioPacienteAtendidoRepository'
import parametrizacao from './parametrizacaoRepository'
import formulaExame from './formulaExameRepository'
import jornada from './jornadaRepository'
import agendamentoExame from './agendamentoExameRepository'
import lancamentoColeta from './lancamentoColetaRepository'
import mapaProducao from './mapaProducaoRepository'
import lancamentoResultado from './lancamentoResultadoRepository'
import assinaturaEletronica from './assinaturaEletronicaRepository'
import impressaoExame from './impressaoExameRepository'
import importarLaudo from './importarLaudoRepository'
import entregaExame from './entregaExameRepository'
import exameAgendadoRealizado from './exameAgendadoRealizadoRepository'
import impressoes from './impressoesRepository'
import coletaAgendada from './coletaAgendadaRepository'
import mapaDia from './mapaDiaRepository'
import agendamentoExameRetroativo from './agendamentoExameRetroativoRepository'
import cancelamentoResultado from './cancelamentoResultadoRepository'
import relatorioCotaConsumo from './relatorioCotaConsumoRepository'
import exameSolicitadoStatus from './exameSolicitadoStatusRepository'
import exameProducao from './exameProducaoRepository'
import relatorioFinanceiroPaciente from './relatorioFinanceiroPacienteRepository'
import relatorioColetaRealizada from './relatorioColetaRealizadaRepository'
import relatorioFinanceiroExame from './relatorioFinanceiroExameRepository'
import relatorioHistoricoPaciente from './relatorioHistoricoPacienteRepository'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducaoRepository'
import relatorioQuantitativoExameSolicitado from './relatorioQuantitativoExameSolicitadoRepository'
import relatorioExameLaboratorioApoio from './relatorioExameLaboratorioApoioRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/exame-laboratorial`

    return {
        relatorioExameBloqueado:relatorioExameBloqueado(baseUrl),
        relatorioPacienteAtendido: relatorioPacienteAtendido(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        formulaExame: formulaExame(baseUrl),
        jornada: jornada(baseUrl),
        agendamentoExame: agendamentoExame(baseUrl),
        lancamentoColeta: lancamentoColeta(baseUrl),
        mapaProducao: mapaProducao(baseUrl),
        lancamentoResultado: lancamentoResultado(baseUrl),
        assinaturaEletronica: assinaturaEletronica(baseUrl),
        impressaoExame: impressaoExame(baseUrl),
        importarLaudo: importarLaudo(baseUrl),
        entregaExame: entregaExame(baseUrl),
        exameAgendadoRealizado: exameAgendadoRealizado(baseUrl),
        impressoes: impressoes(baseUrl),
        coletaAgendada: coletaAgendada(baseUrl),
        mapaDia: mapaDia(baseUrl),
        agendamentoExameRetroativo: agendamentoExameRetroativo(baseUrl),
        cancelamentoResultado: cancelamentoResultado(baseUrl),
        relatorioCotaConsumo: relatorioCotaConsumo(baseUrl),
        exameSolicitadoStatus: exameSolicitadoStatus(baseUrl),
        exameProducao: exameProducao(baseUrl),
        relatorioFinanceiroPaciente: relatorioFinanceiroPaciente(baseUrl),
        relatorioColetaRealizada: relatorioColetaRealizada(baseUrl),
        relatorioFinanceiroExame: relatorioFinanceiroExame(baseUrl),
        relatorioQuantitativoProducao: relatorioQuantitativoProducao(baseUrl),
        relatorioQuantitativoExameSolicitado: relatorioQuantitativoExameSolicitado(baseUrl),
        relatorioHistoricoPaciente: relatorioHistoricoPaciente(baseUrl),
        relatorioExameLaboratorioApoio: relatorioExameLaboratorioApoio(baseUrl)
    }
}
